import { combineReducers } from "redux";

import { initializingReducer } from "@redux/initialState";
import createReducerManager from "@redux/reducerManager";
import {
    $DataModuleName,
    IApiDataState,
    IValueState,
    TApiAction,
    TValueAction,
} from "@redux/store.types";

import ApiErrorsModule from "./api/errors/errors.reducer";
import { $ApiErrorsModuleName } from "./api/errors/errors.types";
import LoadingModule from "./api/loading/loading.reducer";
import { $LoadingModuleName } from "./api/loading/loading.types";
import { $ErrorsModuleName, TErrorsState } from "./value/errors/errors.types";
import {
    $FlyoutCategoriesModuleName,
    FlyoutCategory,
} from "./value/flyoutCategories/flyoutCategories.types";
import {
    $ProductDetailModuleName,
    TProductDetailState,
} from "./value/productDetail/productDetail.types";
import { $SearchModuleName, SearchState } from "./value/search/search.types";
import {
    $TranslationsModuleName,
    TTranslationsState,
} from "./value/translations/translations.types";

export const apiDataReducerManager = createReducerManager<
    IApiDataState,
    TApiAction
>();

export const apiReducer = combineReducers({
    [$LoadingModuleName]: LoadingModule,
    [$ApiErrorsModuleName]: ApiErrorsModule,
    [$DataModuleName]: apiDataReducerManager.reduce,
});

export const valueReducerManager = createReducerManager<
    IValueState,
    TValueAction
>({
    [$TranslationsModuleName]: initializingReducer<TTranslationsState>(
        $TranslationsModuleName,
    ),
    [$ProductDetailModuleName]: initializingReducer<TProductDetailState>(
        $ProductDetailModuleName,
    ),
    [$FlyoutCategoriesModuleName]: initializingReducer<FlyoutCategory>(
        $FlyoutCategoriesModuleName,
    ),
    [$ErrorsModuleName]: initializingReducer<TErrorsState>($ErrorsModuleName),
    [$SearchModuleName]: initializingReducer<SearchState>($SearchModuleName),
});
